import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { ReviewList } from '@/widgets/review-list';

/** 어드민 후기 관리(/reviews) — 목록 위젯을 조합만 한다. */
export const ReviewsPage = (): ReactElement => (
  <>
    <PageHeader title="후기 관리" description="고객 후기를 확인하고 부적절한 후기를 숨깁니다." />
    <ReviewList />
  </>
);
